// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
// RxJS
import { Subscription } from 'rxjs';
// Auth
import { AuthNotice, AuthNoticeService, Register } from '../../../../core/auth/';
//import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { InfoDialogComponent } from '../../../../core/_shared/dialogs/info-dialog/info-dialog.component';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { WebApiService } from '../../../../core/_services/WebApiService';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'kt-auth-notice',
	templateUrl: './auth-notice.component.html',
})
export class AuthNoticeComponent implements OnInit, OnDestroy {
	@Output() type: any;
	@Output() message: any = '';

	// Private properties
	private subscriptions: Subscription[] = [];
	code: string;
	email: string;

	/**
	 * Component Constructure
	 *
	 * @param authNoticeService
	 * @param cdr
	 */
	constructor(public authNoticeService: AuthNoticeService, private cdr: ChangeDetectorRef,
		public dialog: MatDialog,
		private http: HttpClient,
		private webApi:WebApiService) {
	}

	/*
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
    */

	/**
	 * On init
	 */
	ngOnInit() {
		this.subscriptions.push(this.authNoticeService.onNoticeChanged$.subscribe(
			(notice: AuthNotice) => {


				notice = Object.assign({}, { message: '', type: '', code: 0 }, notice);


				let regex = /\<input\s+type\s*\=\s*\'hidden\'\s*value\=\'([0-9]+)'\s*value2\=\'([^\']+)'\/>/;

				let result = regex.exec(notice.message);

				console.log(notice.message);

				if (result != null && result.length >= 3) {
					this.code = result[1];

					this.email = result[2];
				}



				this.message = notice.message;

				this.type = notice.type;

				this.cdr.markForCheck();
			}
		));
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}

	resendConfirmation(email: string) {
		let that = this;

		const url = this.webApi.GetApiAddress() + '/ApplicationUser/SendConfirmEmail/' + btoa(  this.email);  ///Login

		console.log(url);

		this.http.get(url).toPromise().then(()=>
		{
				that.showDialog(this.email);
		});
		


	}

	public showDialog(email: string): void {

		let content = "Reenviamos a confirmação para o email : " + email;
		const dialogRef = this.dialog.open(InfoDialogComponent, {
			width: '500px',
			data: { title: 'Reenvio de confirmação', content }
		});

		dialogRef.afterClosed().subscribe(result => {

			if (result == "ok") {

			}
		});

	}

}
